import React, { useState , useEffect } from 'react';
import PropTypes from 'prop-types';
import './Header.scss';
import { NavLink, useNavigate } from 'react-router-dom';
import profileImage from '../../images/avatars/cartoon-avatar.jpg'

const Header = () => {

  const hostUrl = 'http://localhost:8142/'

  const navigate = useNavigate()

  const [menuToggle , setMenuToggle] = useState(false);

  const handleRightMenu = () => {
    setMenuToggle(!menuToggle)
  }

  const [mouseEvent , setMouseEvent] = useState('');
  const [sideActiver , setSideActiver] = useState(false);
  const [userToken , setUserToken] = useState(null);
  const [userData , setUserData] = useState('')

  const userHandler = async() => {
    const token = localStorage.getItem('userToken');
    const userData = localStorage.getItem('userDetails');
    if (token) {
      const parsedToken = JSON.parse(token);
      setUserToken(parsedToken);
    }
    if (userData) {
      const parsedUser = JSON.parse(userData)
      setUserData(parsedUser)
    }
  }


  const removeUser = () => {
    localStorage.removeItem('userToken');
    localStorage.removeItem('userDetails');
    window.location.reload()
  }

  const handleLogin = () => {
    navigate('/login')
  }

  // console.log(userToken ,"uswer")

  const handleMouseState = (link) => {
    setMouseEvent(link)
  }
  
  // console.log(mouseEvent)

  useEffect(() => {
    userHandler();
    
    // Optionally, listen to storage events to detect changes across tabs
    const handleStorageChange = () => {
      userHandler();
    };
    
    window.addEventListener('storage', handleStorageChange);
    // Define the positions for each link
    const positionMap = {
      'link1': '7%',
      'link2': '38%',
      'link3': '74%',
      "" : '-30%'
    };

    // Set the position of .dot-romer based on the mouseEvent
    const dotRomer = document.querySelector('.dot-romer');
    if (dotRomer && positionMap[mouseEvent]) {
      dotRomer.style.left = positionMap[mouseEvent];
    }

    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };


  }, [mouseEvent]);


  window.addEventListener("scroll", () => {
    if (window.pageYOffset > 300) {
      setSideActiver(true)
    }
    if(window.pageYOffset <= 20) {
      setSideActiver(false)
    }
  });



  return (
    <div className="Header">
      <div className={`header-section-inner bg-white relative py-4 border-b`}>
        <div className="container">
          <div className="header-strip flex items-center justify-between">
            <button type='button' onClick={() => navigate('/')} className="header-logo flex items-center gap-4 svg-logo-header">
              <svg xmlns="http://www.w3.org/2000/svg" width="32" height="40" viewBox="0 0 174 200" fill="none">
                <path d="M157.688 58.9623L173.211 49.997L86.6054 0L0 49.997V150.003L86.6054 200L173.211 150.003V97.0175L86.6054 47.0205L40.7234 73.5132V82.5971L103.943 119.099V124.921L86.6054 135.061L40.7234 108.568V126.487L86.6054 152.98L132.487 126.487V117.403L64.1091 77.9247L86.6054 64.9392L157.688 105.971V141.038L86.6054 182.069L15.5233 141.038V58.9623L86.6054 17.9306L157.688 58.9623Z" fill="#080808"/>
              </svg>
              <h2 className=' text-homeblack font-semibold relative font-Inter text-2xl'>SG CODES <span></span></h2>
            </button>
            <div className="header-navigation sm:hidden">
              <nav className='flex items-center gap-12 relative overflow-hidden'>
                  <ul className='flex items-center gap-10 px-6 py-3'>
                    <li><NavLink className='text-homeblack relative font-Manrope text-base duration-300' onMouseEnter={() => handleMouseState('link1')} onMouseLeave={() => handleMouseState('')} to={'/'}>Home</NavLink></li>
                    <li><NavLink className=' relative font-Manrope text-base duration-300' onMouseEnter={() => handleMouseState('link2')} onMouseLeave={() => handleMouseState('')}  to={'/About-Me'}>About Me</NavLink></li>
                    <li><NavLink className='text-homeblack relative font-Manrope text-base duration-300' onMouseEnter={() => handleMouseState('link3')} onMouseLeave={() => handleMouseState('')} to={'/Contact-Me'}>Contact</NavLink></li>
                  </ul>
                  <div className="dot-romer w-[50px] h-[2px] rounded-full bg-red-400 absolute bottom-2 left-[8%] duration-300 ease-in-out">

                  </div>               
              </nav>
            </div>
            <div className="side-menu-button flex items-center gap-8">
              {userToken === null ?  <div className="last-login-button lg:hidden">
                <button onClick={() => navigate('/login')} type="button" className='bg-greenYellow text-homeblack font-Manrope font-semibold px-6 rounded-full py-[5px] text-sm hover:text-white hover:bg-homeblack duration-300'>Login</button>
              </div> : null}
              <button onClick={handleRightMenu} className={`font-Fira menu-toggler-button py-1 text-Primary relative w-7 h-6 flex flex-col justify-between items-end ${menuToggle ? 'menuactive' : 'menunotactive'}`}>
                <div className="lines h-[2px] duration-500 bg-homeblack w-full line-1"></div>
                <div className="lines h-[2px] duration-500 bg-homeblack w-[70%] top-1/2 line-2"></div>
                <div className="lines h-[2px] duration-500 bg-homeblack w-[40%] bottom-0 line-3"></div>
              </button>
            </div>
            <div className={`left-side-menu-section fixed h-[96%] overflow-hidden rounded-3xl w-[250px] bg-homeblack pb-8 top-1/2 z-[999] duration-500 ${menuToggle ? 'left-menuactive left-4' : ' -left-full left-menunonactive'} shadow-2xl`}>
                <div className="inner-left-side-submenu-sec overflow-y-auto h-full ">
                  {userToken === null ? 
                    <div className={`top-profile-section relative flex items-center gap-4  px-4 py-6 border-b border-opacity-30 duration-700 ${sideActiver ? 'bg-white border-homeblack border-opacity-50' : 'bg-homeblack'}`}>
                      <button type='button' onClick={() => navigate('/')} className="header-logo flex items-center gap-4 svg-logo-header">
                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="40" viewBox="0 0 174 200" fill="none">
                          <path d="M157.688 58.9623L173.211 49.997L86.6054 0L0 49.997V150.003L86.6054 200L173.211 150.003V97.0175L86.6054 47.0205L40.7234 73.5132V82.5971L103.943 119.099V124.921L86.6054 135.061L40.7234 108.568V126.487L86.6054 152.98L132.487 126.487V117.403L64.1091 77.9247L86.6054 64.9392L157.688 105.971V141.038L86.6054 182.069L15.5233 141.038V58.9623L86.6054 17.9306L157.688 58.9623Z" fill={`${sideActiver ? '#080808' : '#fff'}`}/>
                        </svg>
                        <h2 className={`${sideActiver ? 'text-homeblack' : 'text-white'} font-semibold relative font-Inter text-2xl`}>SG CODES <span></span></h2>
                      </button>
                      {sideActiver ? <div className="closer-button-subside absolute top-2 right-2 w-8 h-8 rounded-full bg-homeblack flex items-center justify-center">
                        <button type="button" onClick={() => setMenuToggle(false)}>
                          <i className="bi bi-chevron-left text-white"></i>
                        </button></div> : null}
                    </div> : 
                    <div className={`top-profile-section relative flex items-center gap-4  px-4 py-4 border-b border-opacity-30 duration-700 ${sideActiver ? 'bg-white border-homeblack border-opacity-50' : 'bg-homeblack'}`}>
                        <div className="left-image w-16 h-16 rounded-full border-greenYellow border-4 overflow-hidden">
                          <img src={hostUrl + userData?.profileImage} className='w-full h-full object-cover' alt="" />
                        </div>
                      <div className="right-details-sec">
                        <h2 className={`${sideActiver ? 'text-homeblack' : 'text-white'} duration-700  font-Manrope font-bold`}>{userData ? userData?.userName : 'Example Name'}</h2>
                        <p className={`${sideActiver ? 'text-homeblack' : 'text-white'} duration-700 font-DmSans text-sm`}>{userData ? userData?.email : 'Email'}</p>
                      </div>
                      {sideActiver ? <div className="closer-button-subside absolute top-2 right-2 w-8 h-8 rounded-full bg-homeblack flex items-center justify-center"><button type="button" onClick={() => setMenuToggle(false)}><i className="bi bi-chevron-left text-white"></i></button></div> : null}
                    </div>
                  }
                  <div className="menu-sections-side-sub py-4">
                    <div className="middle-small-heads px-4">
                      <h4 className='text-greenYellow text-xs font-Manrope opacity-60'>MAIN PAGES</h4>  
                    </div>  
                    <ul className='flex flex-col pb-5'>
                      <li><NavLink className='relative font-Manrope text-white duration-300 px-4 py-2 hover:bg-white hover:bg-opacity-20' to={'/'}>Home</NavLink></li>
                      <li><NavLink className='relative font-Manrope text-white duration-300 px-4 py-2 hover:bg-white hover:bg-opacity-20' to={'/About-Me'}>About Me</NavLink></li>
                      <li><NavLink className='relative font-Manrope text-white duration-300 px-4 py-2 hover:bg-white hover:bg-opacity-20' to={'/Contact-Me'}>Contact</NavLink></li>
                    </ul> 
                    <div className="middle-small-heads px-4">
                      <h4 className='text-greenYellow text-xs font-Manrope opacity-60'>LEARNING PAGES</h4>  
                    </div>  
                    <ul className='flex flex-col pb-2'>
                      <li><NavLink className='relative font-Manrope text-white duration-300 px-4 py-2 hover:bg-white hover:bg-opacity-20' to={'/LearnReact'}>Learn React</NavLink></li>
                      <li><NavLink className='relative font-Manrope text-white duration-300 px-4 py-2 hover:bg-white hover:bg-opacity-20' to={'/LearnAngular'}>Learn Angular</NavLink></li>
                      <li><NavLink className='relative font-Manrope text-white duration-300 px-4 py-2 hover:bg-white hover:bg-opacity-20' to={'/LearnHtml'}>Learn Html</NavLink></li>
                      <li><NavLink className='relative font-Manrope text-white duration-300 px-4 py-2 hover:bg-white hover:bg-opacity-20' to={'/LearnCss'}>Learn CSS</NavLink></li>
                      <li><NavLink className='relative font-Manrope text-white duration-300 px-4 py-2 hover:bg-white hover:bg-opacity-20' to={'/LearnTailwind'}>Learn Tailwind</NavLink></li>
                      <li>{ userToken ? <button type="button" onClick={removeUser} className='relative font-Manrope text-white duration-300  py-2 hover:bg-white hover:bg-opacity-20 font-semibold  px-4 w-full text-left'>Log Out</button>  : <button type="button" onClick={handleLogin} className='relative font-Manrope text-white duration-300  py-2 hover:bg-white hover:bg-opacity-20 font-semibold  px-4 w-full text-left'>Log In</button>}</li>
                    </ul> 
                  </div> 
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

Header.propTypes = {};

Header.defaultProps = {};

export default Header;
